import { useMutation } from '@tanstack/react-query';
import { graphqlFetch } from '@/utils/graphqlFetch';
import { GenerateSummaryInput, GenerateSummaryOutput } from '../gql/graphql';
import { GENERATE_SUMMARY } from '../mutations/generateSummary';

export const useGenerateSummary = () => {
  return useMutation<GenerateSummaryOutput, Error, GenerateSummaryInput>({
    mutationFn: async (input) => {
      const data = await graphqlFetch<
        { generateSummary: GenerateSummaryOutput },
        { input: GenerateSummaryInput }
      >(GENERATE_SUMMARY, { input });
      return data.generateSummary;
    },
  });
};
